/* =========================================================
   KYUDO COLLECTIONS — ARTICLE JS
   ========================================================= */

(() => {
  'use strict';


  const initializeArticle = (root) => {

    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';


    const shareButton = root.querySelector(
      '[data-kyudo-share]'
    );

    const shareLabel = root.querySelector(
      '[data-kyudo-share-label]'
    );


    if (!shareButton) {
      return;
    }


    shareButton.addEventListener(
      'click',
      async () => {

        const shareData = {
          title: document.title,
          text: root.querySelector(
            '.kyudo-article__title'
          )?.textContent.trim() || document.title,
          url: window.location.href
        };


        /*
         * Native mobile/browser share.
         */

        if (
          navigator.share &&
          typeof navigator.share === 'function'
        ) {

          try {

            await navigator.share(
              shareData
            );

            return;

          } catch (error) {

            /*
             * User cancelled share.
             * Do nothing.
             */
            if (
              error &&
              error.name === 'AbortError'
            ) {
              return;
            }
          }
        }


        /*
         * Clipboard fallback.
         */

        try {

          if (
            navigator.clipboard &&
            navigator.clipboard.writeText
          ) {

            await navigator.clipboard.writeText(
              window.location.href
            );

          } else {

            const textarea =
              document.createElement('textarea');

            textarea.value =
              window.location.href;

            textarea.setAttribute(
              'readonly',
              ''
            );

            textarea.style.position =
              'fixed';

            textarea.style.opacity =
              '0';

            textarea.style.pointerEvents =
              'none';

            document.body.appendChild(
              textarea
            );

            textarea.select();

            document.execCommand(
              'copy'
            );

            textarea.remove();
          }


          /*
           * Small visual confirmation.
           */

          if (shareLabel) {

            const original =
              shareLabel.textContent;

            shareLabel.textContent =
              'Copied';

            window.setTimeout(
              () => {
                shareLabel.textContent =
                  original;
              },
              1800
            );
          }

        } catch (error) {

          /*
           * Clipboard unavailable.
           * No disruptive error is shown to the customer.
           */
        }

      }
    );
  };


  const initializeAll = () => {

    document
      .querySelectorAll('[data-kyudo-article]')
      .forEach(initializeArticle);

  };


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll,
      { once: true }
    );

  } else {

    initializeAll();

  }


  /*
   * Shopify Theme Editor support.
   */

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );

})();